import React, { Component } from "react";
import { Table, Button, Col, Tooltip, Row, Modal, DatePicker } from "antd";
import axios from "axios";
import "./Pages.css";
import VendasGradePrintModal from "../relatorios/VendasGradePrintModal";
import moment, { parseTwoDigitYear } from "moment-timezone";
import numeral from "numeral";
import { getUsuario } from "../utils/LoginManager";
import FiltrosForm from '../components/FiltrosForm';
import { prototype } from "google-map-react";

const dateFormat = 'DD/MM/YYYY'
const { RangePicker } = DatePicker;
const { Column } = Table;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,

    columns: 0,

    formFiltroVisivel: false,
    filtros: {
      tipoTela: 'VENGRADE',
      buscaOrdem: { campo: 'usu_nome', ordem: 'ASC' },
      buscaDataIni: moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('DD/MM/YYYY'),
      buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY'),
      buscaMes: 0,
      buscaAno: 0,
      buscaPessoa: { key: '0', },
      buscaUsuario: { key: '0', },
      buscaMunicipio: { key: '0', },
      buscaGrupoProduto: { key: '0' },
      buscaProduto: { key: '0' },
      buscaTipo: { key: 'X' },
      buscaControle: '',
      buscaAtividade: { key: '0', },
      buscaTipoAtiv: { key: 'X' },
    }

  };

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({
      usuario,
    }, this.getListaRegistros);
  }

  componentDidUpdate(antProps, antState) {
    // const { total, pagina, limite } = this.state;
    // const ultimaPagina = Math.ceil(total / limite);
    // if (pagina > 1 && pagina > ultimaPagina) {
    //   this.setState({
    //     pagina: ultimaPagina
    //   }, this.getListaRegistros)
    // }
  }


  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregando: true });
    const { buscaOrdem, buscaDataIni, buscaDataFim, buscaPessoa, buscaUsuario, buscaProduto } = this.state.filtros;

    if ((buscaDataIni) && (buscaDataFim)) {

      let dataIni = '';
      if ((buscaDataIni) && (buscaDataIni !== undefined)) {
        dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }
      let dataFim = '';
      if ((buscaDataFim) && (buscaDataFim !== undefined)) {
        dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }

      axios
        .get('/vendas/listaVendasGrade', {
          params: {
            campoOrdem: buscaOrdem.campo,
            tipoOrdem: buscaOrdem.ordem,
            pessoa: buscaPessoa.key,
            vendedor: buscaUsuario.key,
            produto: buscaProduto.key,
            dataIni,
            dataFim,
          }
        })
        .then(response => {

          // console.log('getListaRegistros: ', response.data)

          const listaReg = response.data.dados;
          const colunasTipos = response.data.colunasTipos;
          const colunasTam = response.data.colunasTam;
          let qtdeReg = 0;
          let cols = [];
          let data = [];
          let columns = [{
            title: "Produto",
            dataIndex: "prod_descricao",
            key: "prod_descricao",
            width: "20%",
            align: 'left',
          }];

          for (let i = 0; i < colunasTipos.length; i = i + 1) {
            // console.log('regListTipos: ', colunasTipos[i].gtp_descricao)
            qtdeReg = 0;
            cols = [];
            for (let j = 0; j < colunasTam.length; j = j + 1) {
              // console.log('regListColunas: ', colunasTipos[i].gtp_descricao + '/' + colunasTam[j].gtp_descricao + '/' + colunasTam[j].gtam_descricao)
              if (colunasTipos[i].gtp_idf === colunasTam[j].gtpt_tipo) {
                // console.log('regListTipos OKOK: ', colunasTam[j].gtam_descricao)
                qtdeReg++;
                cols.push({
                  title: colunasTam[j].gtam_descricao,
                  dataIndex: 'TP' + colunasTipos[i].gtp_idf + 'TAM' + String(colunasTam[j].gtpt_tamanho),
                  key: String(colunasTam[j].gtpt_tamanho),
                  align: "center"
                })
              }
            }

            if (qtdeReg) {
              columns.push({
                title: colunasTipos[i].gtp_descricao,
                children: qtdeReg ? cols : {}
              })
            }

          }

          for (let x = 0; x < listaReg.length; x = x + 1) {
            data.push({
              prod_descricao: listaReg[x].prod_descricao,
              total: listaReg[x].qtde_total,
            })
            for (let y = 0; y < listaReg[x].grades.length; y = y + 1) {
              const reg = 'TP' + listaReg[x].grades[y].vig_tipo_grade + 'TAM' + listaReg[x].grades[y].vig_tam_grade;
              data[x][reg] = listaReg[x].grades[y].qtde;

              const regT = 'TOTTP' + listaReg[x].grades[y].vig_tipo_grade;
              const qtdeRer = data[x][regT] ? parseFloat(data[x][regT]) : 0;
              data[x][regT] = qtdeRer + listaReg[x].grades[y].qtde;
            }
          }


          for (let i = 0; i < colunasTipos.length; i = i + 1) {
            columns.push({
              title: "TOT " + colunasTipos[i].gtp_descricao,
              dataIndex: "TOTTP" + colunasTipos[i].gtp_idf,
              key: "TOTTP" + colunasTipos[i].gtp_idf,
              width: "5%",
              fixed: 'center',
              align: 'center'
            })
          }

          columns.push({
            title: "TOTAL",
            dataIndex: "total",
            key: "total",
            width: "5%",
            fixed: 'center',
            align: 'center'
          })

          // data.push({
          //   prod_descricao: 'TOTAL GERAL  ',
          //   total: 0,
          // })

          for (let i = 0; i < data.length; i = i + 1) {
            // columns.push({
            //   title: "TOT " + colunasTipos[i].gtp_descricao,
            //   dataIndex: "TOTTP" + colunasTipos[i].gtp_idf,
            //   key: "TOTTP" + colunasTipos[i].gtp_idf,
            //   width: "5%",
            //   fixed: 'center',
            //   align: 'center'
            // })
          }



          // columns.unshift({
          //   title: "Produto",
          //   dataIndex: "prod_descricao",
          //   key: "prod_descricao",
          //   width: "20%",
          //   fixed: 'left',
          // })

          // const columns1 = [
          //   {
          //     title: 'Produto',
          //     dataIndex: 'prod_descricao',
          //     key: 'prod_descricao',
          //     width: 100,
          //     fixed: 'left',
          //   },
          //   {
          //     title: 'ADULTO',
          //     children: [
          //       {
          //         title: 'P',
          //         dataIndex: '1',
          //         key: '1',
          //       },
          //       {
          //         title: 'M',
          //         dataIndex: '2',
          //         key: '2',
          //       },
          //     ],
          //   },
          //   {
          //     title: 'INFANTIL',
          //     children: [
          //       {
          //         title: 'P',
          //         dataIndex: '1',
          //         key: '1',
          //       },
          //       {
          //         title: 'M',
          //         dataIndex: '2',
          //         key: '2',
          //       },
          //     ],
          //   }
          // ];

          // console.log('regListTipos OKOK: ', listaReg)
          // console.log('regListTipos OKOK: ', columns)
          // console.log('regListTipos OKOK: ', data)

          this.setState({
            listaRegistros: data,
            columns,
            carregando: false,
          });

        })
        .catch(erro => {
          console.warn(erro);
          this.setState({
            carregando: false,
          });
        });
    } else {
      this.setState({
        listaRegistros: [],
        carregando: false,
      });
    }
  };




  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { filtros } = this.state;
    filtros[id] = value;
    this.setState({
      [id]: value
    },
      this.getListaRegistros
    );
  };


  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaOrdem: this.state.filtros.buscaOrdem,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaMes: this.state.filtros.buscaMes,
        buscaAno: this.state.filtros.buscaAno,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaUsuario: this.state.filtros.buscaUsuario,
        buscaMunicipio: this.state.filtros.buscaMunicipio,
        buscaGrupoProduto: this.state.filtros.buscaGrupoProduto,
        buscaProduto: this.state.filtros.buscaProduto,
        buscaTipo: this.state.filtros.buscaTipo,
        buscaControle: this.state.filtros.buscaControle,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros(filtros)
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };



  renderValor = (vlr) => {
    return (
      <span> {numeral(vlr).format('0,000.00')} </span>
    );
  };



  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { columns, listaRegistros, carregando, filtros, formFiltroVisivel } = this.state;

    // console.log('VendasGradePage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <h2 className="tituloPage">Grade para Produção</h2>
        <hr />
        <br />

        <Row>
          <div className="pageFiltro" style={{ height: 20 }}>
            <Col xs={24} >

              <Row xs={24} style={{}}>
                <Col xs={2} style={{ width: 110, marginTop: -7 }}>
                  <Button
                    onClick={this.onAbrirFiltroClick}
                    className="pageFiltro-filtrar"
                    style={{ marginRight: 15 }}
                  >
                    Filtrar
                  </Button>
                </Col>

                <FiltrosForm
                  visivel={formFiltroVisivel}
                  onFiltrarClick={this.onFiltrarClick}
                  onCancelarFiltroClick={this.onCancelarFiltroClick}
                  filtros={filtros}
                />


                <Col xs={2} style={{ width: 110, marginTop: -7 }}>
                  <VendasGradePrintModal
                    filtros={filtros}
                    listaRegistros={listaRegistros}
                    columns={columns}
                  />
                </Col>

              </Row>
            </Col>

          </div>
        </Row>

        <Row>
          <div style={{ marginTop: 10 }}>
            <Table
              pagination={false}
              loading={{
                spinning: carregando,
                tip: 'Carregando. Aguarde...',
                size: "large"
              }}
              bordered
              dataSource={listaRegistros}
              columns={columns}
              // scroll={{ x: 600 }}
              rowKey={(registro => registro.prod_descricao)}
            />
          </div>
        </Row>

        {/* <Row style={{ background: "#ececec", padding: 5, marginTop: 10, marginLeft: 220 }}>
          <Col xs={24} sm={2} style={{ paddingRight: 5, textAlign: "right", background: "white", fontSize: 13 }} >
            <Row><span style={{ color: this.state.vlrJan > this.state.MetaJan ? "#10734a" : "#b71c1c" }}>{this.renderValor(this.state.vlrJan)}</span></Row>
          </Col>
          <Col xs={24} sm={2} style={{ paddingRight: 5, textAlign: "right", background: "white", fontSize: 13 }} >
            <Row><span style={{ color: this.state.vlrFev > this.state.MetaFev ? "#10734a" : "#b71c1c" }}>{this.renderValor(this.state.vlrFev)}</span></Row>
          </Col>
          <Col xs={24} sm={2} style={{ paddingRight: 5, textAlign: "right", background: "white", fontSize: 13 }} >
            <Row><span style={{ color: this.state.vlrMar > this.state.MetaMar ? "#10734a" : "#b71c1c" }}>{this.renderValor(this.state.vlrMar)}</span></Row>
          </Col>
        </Row> */}

      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/VendasGradePage.js